import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {KeliChartBehavior} from './keli-chart-behavior.js';
import {Chart, BarController, BarElement} from 'chart.js';
Chart.register(BarController, BarElement);

class KeliChartBar extends ScopeBinding(KeliChartBehavior(PolymerElement)) {
  static get template() {
    return html`
<style>
:host {
  display: block;
}
</style>
<keli-chart-controller id="controller" keliname="_t"></keli-chart-controller>
<div id="outerChartContainer">
  <div id="chartContainer">
    <canvas id="chartElement" width="400" height="200"></canvas>
  </div>
</div>`;
  }

  static get is() {
    return 'keli-chart-bar';
  }

  static get properties() {
    return {
      keliControlTypes: {type: Array, value: ['barchart']},
      chartType: {type: String, value: 'bar'},
      stacked: {type: Boolean, scopevar: true, observer: 'stackedChanged'}
    }
  }

  stackedChanged(newValue) {
    if (this.chart) {
      Object.assign(this.chart.options, {
        scales: {
          x: {stacked: newValue},
          y: {stacked: newValue}
        }
      });
      this.chart.update();
    }
  }
}

customElements.define(KeliChartBar.is, KeliChartBar);
export {KeliChartBar};
